import { takeLatest, put, all } from "redux-saga/effects";
import { getPath, getSessionStorageKey } from "../../../utils";
import { toast } from "react-toastify";
import history from "../../../services/history";
import HttpService from "../../../services/HttpService";

import { setDataLoginRequest } from "../sessionStorage/actions";
import { getLastActivePlanStatus } from "../billingPlan/actions";
import { generatePathToLogin } from "../../../utils/generateRedirectLoginPath";

export function* doTokenLogin({ payload }) {
	try {
		const { token, noRedirect } = payload;
		let response = yield HttpService.loginUsingExternalToken(token);

		if (response.success) {
			const { investor, multiBroker, billingStatus, accounts } = response.result;

			if (billingStatus.cd_status === "PROC") {
				history.push("/onboard/processando");
				return;
			}

			yield put(setDataLoginRequest(investor, multiBroker, billingStatus, accounts));
			yield put(getLastActivePlanStatus());
			if (noRedirect) return;

			if (["OPEN", "TRIAL"].indexOf(billingStatus.cd_status) !== -1) {
				const token = getSessionStorageKey("TOKEN");

				var path = generatePathToLogin(token);
				window.location.href = getPath(path);
				return;
			}

			if (!path) return;

			history.push(path);
		} else {
			let errorMessage = response.errorMessage ? response.errorMessage : response.message;
			toast.error(errorMessage);
			history.push("/onboard/login");
		}
	} catch (err) {
		history.push("/onboard/login");
		console.error(err);
	}
}

export default all([takeLatest("@token/DO_TOKEN_LOGIN", doTokenLogin)]);
